import Icon from 'vue-awesome/components/Icon'

Icon.register({
  change_history_rounded: {
    paths: [
      {
        d: 'M12 7.77L18.39 18H5.61L12 7.77m-.85-2.41l-8.2 13.11c-.41.67.07 1.53.85 1.53h16.4a1 1 0 00.85-1.53l-8.2-13.11a1 1 0 00-1.7 0z'
      }
    ],
    width: '24',
    height: '24'
  }
})
